<script lang="ts">
  import { MODE_INFO } from '../content/modes';
  import { SOLO_MODES, type GameMode } from '../../shared/modes';
  import { getSession } from '../session/context';
  import ThemeIcon from '../themes/ThemeIcon.svelte';
  import Button from '../ui/Button.svelte';
  import MyRoomsPanel from '../panels/MyRoomsPanel.svelte';

  interface Props {
    screen: 'menu' | 'solo' | 'versus';
    chooseMode: (mode: GameMode) => void;
    navigateMenu: (screen: 'solo' | 'versus' | 'leaderboard') => void;
    openVersus: (screen: 'host' | 'join') => void;
    openRoom: (code: string) => void;
  }
  let { screen, chooseMode, navigateMenu, openVersus, openRoom }: Props = $props();
  const session = getSession();
</script>

{#if screen === 'menu'}
  <section id="screen-menu" class="screen menu-screen">
    <nav class="main-menu" aria-label="Main menu">
      <Button class="menu-option" aria-label="Daily" onclick={() => chooseMode('daily')}
        ><span class="menu-symbol"><ThemeIcon name="daily" /></span><span><strong>Daily</strong></span
        ><ThemeIcon name="next" /></Button
      >
      <Button class="menu-option" aria-label="Competitive" onclick={() => chooseMode('competitive')}
        ><span class="menu-symbol"><ThemeIcon name="competitive" /></span><span
          ><strong>Competitive</strong></span
        ><ThemeIcon name="next" /></Button
      >
      <Button class="menu-option" aria-label="Solo" onclick={() => navigateMenu('solo')}
        ><span class="menu-symbol"><ThemeIcon name="solo" /></span><span><strong>Solo</strong></span
        ><ThemeIcon name="next" /></Button
      >
      <Button class="menu-option" aria-label="Versus" onclick={() => navigateMenu('versus')}
        ><span class="menu-symbol"><ThemeIcon name="versus" /></span><span><strong>Versus</strong></span
        ><ThemeIcon name="next" /></Button
      >
      <Button class="menu-option" aria-label="Leaderboard" onclick={() => navigateMenu('leaderboard')}
        ><span class="menu-symbol"><ThemeIcon name="trophy" /></span><span><strong>Leaderboard</strong></span
        ><ThemeIcon name="next" /></Button
      >
    </nav>
  </section>
{:else if screen === 'solo'}
  <section id="screen-solo" class="screen menu-screen submenu">
    <h1>Solo</h1>
    <div class="main-menu">
      {#each SOLO_MODES as value}<Button
          class="menu-option"
          aria-label={MODE_INFO[value].title}
          onclick={() => chooseMode(value)}
          ><span><strong>{MODE_INFO[value].title}</strong></span><ThemeIcon name="next" /></Button
        >{/each}
    </div>
  </section>
{:else if screen === 'versus'}
  <section id="screen-versus" class="screen menu-screen submenu">
    <h1>Versus</h1>
    <div class="main-menu">
      <Button class="menu-option" aria-label="Join" onclick={() => openVersus('join')}
        ><span><strong>Join</strong></span><ThemeIcon name="next" /></Button
      >
      <Button class="menu-option" aria-label="Host" onclick={() => openVersus('host')}
        ><span><strong>Host</strong></span><ThemeIcon name="next" /></Button
      >
    </div>
    <MyRoomsPanel
      credential={$session.profileCredential}
      profileGeneration={$session.profileGeneration}
      {openRoom}
    />
  </section>
{/if}

<style>
  .menu-symbol {
    font-size: 26px;
    width: 30px;
    text-align: center;
    flex-shrink: 0;
  }

  .menu-screen:not(.submenu) {
    justify-content: flex-start;
    gap: 20px;
    padding: 16px 0 28px;
  }
  .main-menu {
    display: grid;
    gap: 10px;
    width: 100%;
  }
  :global(.btn.menu-option) {
    display: flex;
    align-items: center;
    gap: 16px;
    text-align: left;
    width: 100%;
    padding: 16px 20px;
  }
  :global(.btn.menu-option > .theme-icon:last-child) {
    margin-left: auto;
  }
  :global(.btn.menu-option strong) {
    display: block;
  }
  @media (max-width: 360px) {
    :global(.btn.menu-option) {
      padding: 16px 12px;
      gap: 10px;
    }
  }
</style>
